import React, { useState, useEffect } from 'react';


/**
 * Componente LuchoFest (Para la Pantalla Gigante / Screen)
 * Muestra el estatus del juego: El temporizador gigante, el Ganador, o la Ronda de Prueba.
 */
const LuchoFest = ({ question, isActiveWomensMode }) => {
    // Extraemos la información que nos mandó el switch de Screen.js
    const { viewType, winningZone, totalDuration } = question || {};

    // Estados para el reloj
    const [countdown321, setCountdown321] = useState(3);
    const [gameTimerSeconds, setGameTimerSeconds] = useState(0);
    const [isGameActive, setIsGameActive] = useState(false);

    // ====================================================
    // LÓGICA DE TEMPORIZADORES (Solo cuando viewType es 'playing')
    // ====================================================
    useEffect(() => {
        if (viewType === 'playing') {
            // Reiniciamos todo al entrar a 'playing'
            setCountdown321(3);
            setGameTimerSeconds(totalDuration || 0); // Lo que mandó la API
            setIsGameActive(false);

            // 1. Iniciamos el 3, 2, 1
            let count = 3;
            const prepInterval = setInterval(() => {
                count--;
                setCountdown321(count);
                
                if (count <= 0) {
                    clearInterval(prepInterval);
                    setIsGameActive(true); // Arranca el tiempo del juego
                }
            }, 1000);

            return () => clearInterval(prepInterval);
        }
    }, [viewType, totalDuration]);

    // 2. Iniciamos el reloj grande hacia 0
    useEffect(() => {
        let mainTimer;
        if (isGameActive && gameTimerSeconds > 0) {
            mainTimer = setInterval(() => {
                setGameTimerSeconds(prev => prev - 1);
            }, 1000);
        } else if (gameTimerSeconds <= 0) {
            clearInterval(mainTimer);
        }

        return () => clearInterval(mainTimer);
    }, [isGameActive, gameTimerSeconds]);


    // ====================================================
    // RENDERIZADO
    // ====================================================
    return (
        <>
            {/* FONDO (Reutilizamos la clase que usas en la portada) */}
            <div className='FrontPage--Riddle__Screen__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                ) : (
                    <img src='/img/page/backgrounds/background.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                )}
            </div>

            {/* CONTENIDO SUPERPUESTO */}
            <div className="d-flex flex-column justify-content-center align-items-center" style={{ position: 'absolute', inset: 0, zIndex: 10, textAlign: 'center', color: 'white' }}>
                
                {/* VISTA 1: JUEGO EN CURSO (Relojes) */}
                {viewType === 'playing' && (
                    <div className="p-5" style={{ backgroundColor: 'rgba(0,0,0,0.6)', borderRadius: '30px', border: '5px solid #facc15' }}>
                        {!isGameActive ? (
                            <>
                                <h1 style={{ fontSize: '6rem', fontFamily: '"GFS Didot", serif', marginBottom: '1rem' }}>¡PREPÁRATE!</h1>
                                <div style={{ fontSize: '15rem', fontWeight: '900', color: '#facc15', lineHeight: '1' }}>
                                    {countdown321}
                                </div>
                            </>
                        ) : (
                            <>
                                <h1 style={{ fontSize: '6rem', fontFamily: '"GFS Didot", serif', marginBottom: '1rem' }}>¡A JUGAR!</h1>
                                <div style={{ fontSize: '15rem', fontWeight: '900', color: gameTimerSeconds <= 5 ? '#ef4444' : '#10b981', lineHeight: '1' }}>
                                    {gameTimerSeconds > 0 ? gameTimerSeconds : '0'}
                                </div>
                                <p style={{ fontSize: '3rem', marginTop: '1rem' }}>Segundos restantes</p>
                            </>
                        )}
                    </div>
                )}

                {/* VISTA 2: GANADOR DE RONDA REAL */}
                {viewType === 'winner' && (
                    <div className="p-5 w-75 position-relative" style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)', borderRadius: '40px', border: '10px solid #f97316', color: '#1f2937', boxShadow: '0 25px 50px rgba(0,0,0,0.5)' }}>
                        <h1 style={{ fontSize: '5rem', color: '#ea580c', fontWeight: 'bold' }}>¡TENEMOS GANADOR!</h1>
                        <p style={{ fontSize: '3rem', color: '#6b7280', margin: '2rem 0' }}>La zona que hizo más puntos fue:</p>
                        
                        <div style={{ fontSize: '8rem', fontWeight: '900', color: '#10b981', textTransform: 'uppercase', textShadow: '4px 4px 0px rgba(0,0,0,0.1)' }}>
                            ZONA {winningZone}
                        </div>
                        
                        <p style={{ fontSize: '2.5rem', color: '#ea580c', marginTop: '2rem', fontWeight: 'bold' }}>¡Felicidades! Revisa tu celular para tu premio.</p>

                        {/* Emojis simulando confeti (Opcional: Si tienes una librería de confeti, ponla aquí) */}
                        <div style={{ position: 'absolute', top: '-50px', left: '-50px', fontSize: '6rem' }}>🎉</div>
                        <div style={{ position: 'absolute', top: '-50px', right: '-50px', fontSize: '6rem' }}>🎊</div>
                    </div>
                )}

                {/* VISTA 3: RONDA DE PRUEBA FINALIZADA */}
                {viewType === 'practice' && (
                    <div className="p-5 w-75" style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)', borderRadius: '40px', border: '5px dashed #9ca3af' }}>
                        <h1 style={{ fontSize: '5rem', color: '#facc15', fontWeight: 'bold', marginBottom: '2rem' }}>RONDA DE PRUEBA FINALIZADA</h1>
                        
                        <p style={{ fontSize: '3rem', color: 'white' }}>En esta ocasión la zona más rápida fue:</p>
                        <div style={{ fontSize: '6rem', fontWeight: '900', color: '#60a5fa', textTransform: 'uppercase', margin: '1rem 0' }}>
                            ZONA {winningZone}
                        </div>

                        <p style={{ fontSize: '3rem', color: '#9ca3af', marginTop: '3rem' }}>¿Estás list@ para la ronda por el premio real?</p>
                        <p style={{ fontSize: '2.5rem', color: 'white', fontWeight: 'bold' }}>¡Atento a tu celular!</p>
                    </div>
                )}

            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits' style={{ zIndex: 20, position: 'relative' }}>
                Hecho con ♥ por Interaktia | 2026
            </footer>
        </>
    );
};

export { LuchoFest };